import { Accordion } from '@/components/common/Accordion';
import { CardsContainer } from '@/components/dashboard/DashboardCard';
import DoctorQrCodes from '@/components/dashboard/qr-codes/DoctorQrCodes';
import ManageQrCodesTable from '@/components/dashboard/qr-codes/ManageQrCodesTable';
import ScannedUsersTable from '@/components/dashboard/qr-codes/ScannedUsersTable';
import { Role } from '@/domain/Role';
import { useHasRole } from '@/hooks/useHasRole';
import { cn } from '@/lib/cn';
import { useBreakpoint } from '@/lib/contexts/BreakpointContext';
import { useState } from 'react';

export const QrCodesPage = () => {
  const { isDesktop, isBigDesktop } = useBreakpoint();
  const { hasRole } = useHasRole();
  const isDoctor = hasRole(Role.DOCTOR);
  const [accordionValue, setAccordionValue] = useState('');

  if (isDoctor) {
    return (
      <div className="px-0 py-12.5 md:px-4">
        <div
          className={cn(
            'lg:max-w-305 xl:w-full',
            isBigDesktop ? 'mx-auto' : isDesktop ? 'mx-2' : 'mx-0',
          )}
        >
          <DoctorQrCodes />
        </div>
      </div>
    );
  }

  return (
    <div className="px-0 py-12.5 md:px-4">
      <CardsContainer
        className={cn(
          'md:rounded-0 pt-8 lg:max-w-305 lg:rounded-3xl xl:w-full',
          isBigDesktop ? 'mx-auto' : isDesktop ? 'mx-2' : 'mx-0',
        )}
      >
        <Accordion
          type="single"
          collapsible
          className="w-full space-y-4 border-none"
          value={accordionValue}
          onValueChange={setAccordionValue}
        >
          <ScannedUsersTable />
          <ManageQrCodesTable accordionOpenValue={accordionValue} />
        </Accordion>
      </CardsContainer>
    </div>
  );
};
